import React, {Component} from 'react';
import './NavBar.scss'
import { LanguageToggle } from '../language/ducks/index';
import hrbLogo from '../../resources/images/hrb-logo.svg';
import AccountDropdownToggle from "./account/AccountDropdownToggle";
import AuthenticateItems from './authenticate/AuthenticateItems';
import auth from '../user/services/Auth';

class NavBar extends Component {

  goToHomeRoute = () => {
    this.props.history.push('/');
  };

  render() {
    var isAuthenticated = auth.isAuthenticated();
    return (
        <div className="hrb-navbar">
          <img className="hrb-navbar-logo" src={hrbLogo} alt="hrb-logo" onClick={this.goToHomeRoute}/>
          <div className="hrb-navbar-utilities">
            { isAuthenticated && 
              <div className="hrb-navbar-account">
                <AccountDropdownToggle {...this.props} />
              </div>
            }
            <div className="hrb-navbar-language">
              <LanguageToggle />
            </div>
          </div>
        </div>
    );
  }
}

export default NavBar;